module.exports = "mutation surveyAnswers($answers:[SurveyAnswerInput]!){surveyAnswers(answers:$answers){message status}}"